export function getAppParamsFromResponse(response) {
    return response?.data?.app_params || response?.data?.data?.app_params || [];
}

export function parseAppButtonColors(appParams) {
    if (!Array.isArray(appParams)) {
        return {};
    }

    const colors = {};
    const buttonColorParam = appParams.find((p) => p.key === "appButtonColor");
    const buttonTextColorParam = appParams.find((p) => p.key === "appButtonTextColor");
    const colorVal = buttonColorParam && String(buttonColorParam.value || "").trim();
    const textVal = buttonTextColorParam && String(buttonTextColorParam.value || "").trim();

    if (colorVal) {
        colors.appButtonColor = colorVal;
    }
    if (textVal) {
        colors.appButtonTextColor = textVal;
    }

    return colors;
}
